import { UserCheckIcon } from "@/components/common/icons";
import { GREY } from "@/config/mui/colorPalette";
import AppointmentUpdateStatusRow, {
  Appointment,
} from "./appointmentUpdateStatusRow";

type Props = {
  appointment: Appointment;
  isCheckingInAppointment: boolean;
  checkInAppointmentAction: (appointmentAccessToken: string) => void;
};

export default function AppointmentCheckInRow({
  appointment,
  isCheckingInAppointment,
  checkInAppointmentAction,
}: Props) {
  return (
    <AppointmentUpdateStatusRow
      appointment={appointment}
      isUpdating={isCheckingInAppointment}
      updateAction={checkInAppointmentAction}
      icon={<UserCheckIcon color={GREY[40]} />}
      label="Check in for today's appointment"
      buttonText="Check-in"
    />
  );
}
